<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class=""><i class="fa fa-building"></i><b> My Account Transactions :</b> Invoice Details for {{invoicedetails.InvoiceNumber}}</h5>
                </div>
                <div class="col-3 text-right">
                    <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
                </div>
            </div>
            <hr>
            <div class="col-md-12 p-0 ">
                <div class="card border-light shadow-sm">
                    <div class="row mb-3 ">
                        <img src="../../../../assets/crossboarderHeader1.png" width="100%">
                    </div>
                </div>
            </div>
            <!-- Carrier Account Details -->
            <div class="col-md-12 p-0 ">
                <div class="card border-light shadow-sm">
                    <div class="row mb-3 ">
                        <div style="margin-bottom:10px;" class="col-sm-5 p-0">
                            <div class="col-md-12">
                                <h6 style="margin-bottom:20px;">
                                    <span style="padding-right:5px"></span>
                                    <b>Account Details </b>
                                </h6>
                                <table id="accountdetails-1">
                                    <tbody>
                                        <tr>
                                            <td><span class="head-text">Account ID:</span></td>
                                            <td><span>{{debtoraccount.customer_code}}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text">Account Name:</span></td>
                                            <td><span>{{debtoraccount.customer_name}}</span></td>
                                        </tr>
                                        <!-- <tr>
                  <td><span class = "head-text">My Reference:</span></td>
                  <td><span >{{dataCntrl['application'].reference_num}}</span></td>
                </tr> -->
                                        <tr>
                                            <td><span class="head-text">Contact Person:</span></td>
                                            <td><span>{{debtoraccount.contact_person}}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text">Email:</span></td>
                                            <td><span>{{debtoraccount.email}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div style="margin-bottom:10px; margin-left:10px" class="col-sm-5 p-0">
                            <h6 style="margin-bottom:20px;">
                                <span style="padding-right:5px"></span>
                                <b>Physical Address</b>
                            </h6>
                            <div class="col-md-12">
                                <table id="address-1">
                                    <tbody>
                                        <tr>
                                            <td><span class="head-text">Address Line:</span></td>
                                            <td> {{debtoraccount.physical_address_1}}</td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text">Town:</span></td>
                                            <td>{{debtoraccount.physical_address_town}}</td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text">Post Code:</span></td>
                                            <td><span>{{debtoraccount.physical_post_code}}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span class="head-text">Country:</span></td>
                                            <td>{{debtoraccount.country}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- End of the Carrier Details -->
            <hr>


            <table class="table table-sm table-striped" style="border-top:none;">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">

                        <th scope="col">Item Code</th>
                        <th scope="col">Description</th>
                        <th scope="col">Price Per Unit</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total</th>

                    </tr>
                </thead>
                <tr *ngFor="let invoiceitem of invoicedetails.invoiceItems | paginate: { itemsPerPage: 15, currentPage: page }">
                    <td>{{invoiceitem.ItemCode}}</td>
                    <td>{{invoiceitem.Description}}</td>
                    <td class="text-right">{{invoiceitem.unit_price ? (invoiceitem.unit_price | currencyFormat) : 'R 0.00' }}</td>
                    <td class="text-center">{{invoiceitem.quantity}}</td>
                    <td class="text-right">{{invoiceitem.line_total ? (invoiceitem.line_total| currencyFormat) : 'R 0.00' }}</td>
                </tr>
                <tfoot>
                    <!-- <tr *ngIf="invoicedetails.invoiceItems.length > 0">
            <td colspan="9" class="rm-brd">
              <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
            </td>
          </tr> -->
                    <tr *ngIf="count===0">
                        <td colspan="9" class="rm-brd">
                            <span class="text-info text-small">No Transcations Available for this invoice.</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <div class="text-right">
        <b>Invoice Total: </b>{{invoicedetails.InclusiveTotal ? (invoicedetails.InclusiveTotal| currencyFormat) : 'R 0.00' }}
    </div>
    <br/>
    <br/>
